import { SidePanelType, useSidePanel } from "PFApp/stores/side_panels_store";
import { Id } from "PFCore/types";

import { DetailsPanelData, DetailsPanelType } from "../details_panel.types";

export const useDetailsPanelData = (type: DetailsPanelType, id: Id) =>
  useSidePanel<DetailsPanelData>(`${SidePanelType.BookingDetails}_${type}_${id}`);
